import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';
import { Landing } from '@domgen/base-design-system-2.0/pages/Landing';
import { Maintenance } from '@domgen/base-design-system-2.0/pages/Maintenance';
import Layout from '../Layout';

const { VITE_APP_PATH, VITE_MAINTENANCE_MODE_ENABLED, VITE_PR_ID } = import.meta.env;

const routes = [
  { path: '/', Component: Landing },
  { path: 'landing', Component: Landing },
];

const appPath =
  `${VITE_PR_ID ? `/${VITE_PR_ID}` : ''}${VITE_APP_PATH ? `/${VITE_APP_PATH}` : VITE_PR_ID ? '' : '/'}`.trim();

export const AppRoutes = () => {
  const maintenanceModeEnabled = VITE_MAINTENANCE_MODE_ENABLED;

  return createBrowserRouter(
    createRoutesFromElements(
      <Route element={<Layout />}>
        {maintenanceModeEnabled ? (
          <Route path="*" Component={Maintenance} />
        ) : (
          routes.map(({ path, Component }) => (
            <Route key={path} path={path} Component={Component} />
          ))
        )}
      </Route>,
    ),
    { basename: appPath },
  );
};
